/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  导出: '导出',
  设置: '设置',
  只查看: '只查看',
  批量导出: '批量导出',
  编辑商机: '编辑商机',
  全局对象: '全局对象',
  编辑报价单: '编辑报价单',
  作废报价单: '作废报价单',
  容联外呼人员: '容联外呼人员',
  新增销售合同: '新增销售合同',
  查看审批详情: '查看审批详情',
  编辑销售合同: '编辑销售合同',
  编辑售后服务: '编辑售后服务',
  客户行业分布: '客户行业分布',
  下载通话视角明细: '下载通话视角明细',
  下载人员视角明细: '下载人员视角明细',
  下载日程视角明细: '下载日程视角明细',
  超2日待处理线索数量: '超2日待处理线索数量',
  待处理线索数量: '待处理线索数量',
  '数据看板-线索分析': '数据看板-线索分析',
  '数据看板-客户画像': '数据看板-客户画像',
  '数据看板-成员榜单': '数据看板-成员榜单',
  '分配线索数-飞书GBLeader': '分配线索数-飞书GBLeader',
  '添加/修改/删除客户关键联系人': '添加/修改/删除客户关键联系人',
  '新增/编辑/删除产品价格': '新增/编辑/删除产品价格',
  '新增销售订单(提交)': '新增销售订单(提交)',
  '新增/编辑产品': '新增/编辑产品',
  '添加/编辑跟进': '添加/编辑跟进',
  '添加/编辑联系人': '添加/编辑联系人',
  '新增/管理协作人': '新增/管理协作人',
  '新增/编辑业绩参与人': '新增/编辑业绩参与人',
  '新增/编辑地址信息': '新增/编辑地址信息',
  '新增/编辑开票信息': '新增/编辑开票信息',
  '新增/编辑/删除日程': '新增/编辑/删除日程',
  '新增销售订单(提交并按明细拆分)': '新增销售订单(提交并按明细拆分)',
  '完成阶段/回退至该阶段/结束': '完成阶段/回退至该阶段/结束',
  '上传/复制/下载/删除云文档附件': '上传/复制/下载/删除云文档附件'
};
